import { AgencySchema } from '@ametista-ai/api-schema';
import { ApiPaginatedResponse } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { agenciesKeys } from './keys';

export function useAgencies() {
  return useQuery({
    queryKey: agenciesKeys.list(),
    queryFn: async () => {
      const res = await apiClient.get<ApiPaginatedResponse<AgencySchema>>('/v1/agencies', {
        limit: 100,
      });

      return [...res.data].sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
    },
  });
}
